import React from "react";
import { cn } from "../../../common/u1/cn";
import { Dirham } from "../../../../assets/ui/icons";

/* One billing plan in the membership selector. */
export const PlanCard = ({
  id,
  name = "plan",
  label,
  price,
  unit,
  note,
  footnote,
  footnoteTone = "accent",
  ribbon,
  selected = false,
  onSelect = () => {},
  className = "",
}) => (
  <label
    className={cn(
      "relative block cursor-pointer rounded-2xl border-[1.5px] bg-white p-[22px]",
      "transition-[border-color,box-shadow] duration-150",
      selected
        ? "border-[var(--coral)] shadow-[0_0_0_3px_var(--coral-soft)]"
        : "border-[var(--line)] hover:border-[var(--line-2)]",
      className
    )}
  >
    {ribbon && (
      <span className="absolute -top-[11px] left-[22px] rounded-[30px] bg-[var(--coral)] px-[11px] py-1 text-[11px] font-bold uppercase tracking-[.5px] text-white font-sans">
        {ribbon}
      </span>
    )}

    <span className="flex items-center justify-between">
      <span className="text-[15px] font-bold text-[var(--ink)] font-sans">{label}</span>

      {/* The input is the control; the ring beside it is its painted face. */}
      <input
        type="radio"
        name={name}
        value={id}
        checked={selected}
        onChange={() => onSelect(id)}
        className="peer sr-only"
      />
      <span
        aria-hidden="true"
        className={cn(
          "flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded-full border-2",
          "peer-focus-visible:ring-2 peer-focus-visible:ring-[var(--orange)] peer-focus-visible:ring-offset-2",
          selected ? "border-[var(--coral)]" : "border-[var(--muted-2)]"
        )}
      >
        <span
          className={cn(
            "h-[11px] w-[11px] rounded-full bg-[var(--coral)] transition-opacity duration-100",
            selected ? "opacity-100" : "opacity-0"
          )}
        />
      </span>
    </span>

    <span className="mt-4 mb-1 flex items-baseline gap-1.5">
      <b className="whitespace-nowrap text-[34px] font-bold tracking-[-.01em] text-[var(--ink)] font-sans">
        <Dirham />
        {price}
      </b>
      <span className="text-[14px] text-[var(--muted)] font-sans">{unit}</span>
    </span>

    {note && <span className="block text-[13px] text-[var(--ink-2)] font-sans">{note}</span>}

    {footnote && (
      <span
        className={cn(
          "mt-3 inline-block text-[12px] font-sans",
          footnoteTone === "accent"
            ? "rounded-md bg-[var(--coral-soft)] px-2.5 py-1 font-bold text-[var(--coral-deep)]"
            : "py-1 font-semibold text-[var(--muted-2)]"
        )}
      >
        {footnote}
      </span>
    )}
  </label>
);

export default PlanCard;
